// import Index from './index/index.vue'
// import Consign from './consign/index.vue'
// import Product from './product/index.vue'
// import Contact from './contact/index.vue'
// import Dept from './dept/index.vue'

// export const pages = {
//   index: Index,
//   consign: Consign,
//   product: Product,
//   contact: Contact,
//   dept: Dept,
// }

export const pages = {
  index: () => import('./index/index.vue'),
  consign: () => import('./consign/index.vue'),
  product: () => import('./product/index.vue'),
  contact: () => import('./contact/index.vue'),
  dept: () => import('./dept/index.vue'),
}